import React, { useEffect, useState } from "react";
import Accordion from "../../Reusable/Accordion/Accordion.js";
import list from "./listJSON.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useProfile } from "../../../contexts/profileContext/profileContext.js";
import { useParams } from "react-router-dom";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useUser } from "contexts/userContext/userContext.js";
import Button from "components/Elements/Button/Button.js";

const DisplayMenu = ({ userData }) => {
  const { getTextByKey } = useContent();
  const maxSubmissionsPerMonth = 50;
  const params = useParams();
  const { isBusiness, isPremium } = useUser();
  const { getSubUserData } = useProfile();
  const [newList, setNewList] = useState(list);
  const [hoverUpgradeDiv, setHoverUpgradeDiv] = useState(false);
  const [hoverCountOrders, setHoverCountOrders] = useState(false);
  const [categorySelected, setCategorySelected] = useState(
    params.profileCategory
  );
  const complateReactList = [
    // { name: "Account", link: "Profile_UserData.aspx" },
    // { name: "details", link: "Profile_UserDetails.aspx" },
    // { name: "Notifications", link: "Profile_Settings.aspx" },
    // { name: "Jumbocode", link: "Profile_Codes.aspx" },
    //{ name: "Payments", link: "Profile_Billing.aspx" },
    // { name: "Cover-Logo", link: "Profile_UserBranding.aspx" },
    //{ name: "Email", link: "Profile_UserSignature.aspx" },
    //{ name: "Business-Profile", link: "Profile_BusinessProfile.aspx" },
    // {
    //   name: "Account-Status",
    //   link: "Profile_UserPaymentsStatus.aspx",
    // },
    //{ name: "Received-Payments", link: "Profile_UserPaymentsReceived.aspx" },
    //{ name: "Sent-Payments", link: "Profile_UserPaymentsSent.aspx" },
    //{ name: "Payouts", link: "Profile_UserPaymentsPayouts.aspx" },
    //{ name: "Settings", link: "Profile_UserPaymentsSettings.aspx" },
    // {
    //   name: "Account-Status",
    //   link: "Profile_UserPaymentsStatus.aspx",
    // },
    { name: "received-orders", link: "inbox?t=received&f=jform" },
    //{ name: "Contacts-List", link: "Profile_UserContacts.aspx" },
    //{ name: "Order-Tracker", link: "Profile_EmbedTrackOrders.aspx" },
    //{ name: "activity-reports", link: "Profile_EmbedExport.aspx" },
    //{ name: "For-Developer", link: "Profile_UserEmbedData.aspx" },
  ];

  const advanceList = [
    "statuses-management",
    "order-tracker",
    "ftp",
    "api",
    "integration",
    "activity-reports",
  ];

  useEffect(() => {
    if (
      userData &&
      (userData.UserCountry !== "Israel" || userData.HideJumboPay)
    ) {
      setNewList((prevList) =>
        prevList.filter((item) => item.category !== "jumbopay")
      );
    }

    // removing Jumbocode and Payments from sub user menu
    if (userData?.IsSubUser) {
      setNewList((prevList) => {
        return prevList.map((item) => {
          if (item.category === "profile") {
            return {
              ...item,
              content: item.content.filter(
                (line) => !["Jumbocode", "Payments"].includes(line.name)
              ),
            };
          }
          return item;
        });
      });
    } else if (userData && !userData.JumboCodesEnabled) {
      // removing Jumbocode for users that never used or dont have it
      setNewList((prevList) => {
        return prevList.map((item) => {
          if (item.category === "profile") {
            return {
              ...item,
              content: item.content.filter((line) => line.name !== "Jumbocode"),
            };
          }
          return item;
        });
      });
    }
  }, [userData, getSubUserData().numberOfUsers]);

  const mouseOutCountOrders = () => {
    setTimeout(() => {
      if (!hoverUpgradeDiv) {
        setHoverCountOrders(false);
      }
    }, 500);
  };

  const leaveOutUpgradeDiv = () => {
    setHoverCountOrders(false);
    setHoverUpgradeDiv(false);
  };

  return (
    <div>
      {newList.map((item, i) => (
        <div key={i} className="list-accordion-container">
          <Accordion
            setCategorySelected={setCategorySelected}
            title={
              <div>
                <h3>
                  <Icon iconClass={`title-icon`} name={item.icon} ext="svg" />{" "}
                  {getTextByKey(item.title)}{" "}
                </h3>
              </div>
            }
            categorySelected={categorySelected}
            menuParams={item.category}
            profileUser={true}
            isProfilePages={true}
            defaultShow={true}
            forceHide={categorySelected === item.category ? false : true}
          >
            <ul>
              <>
                {item.content
                  .filter(
                    (line) =>
                      !!userData?.subUsersCount ||
                      userData.IsAdminSubUser ||
                      line.name !== "account-users"
                  )
                  .map((line, i) =>
                    complateReactList.some(
                      (item) =>
                        item.name.toLowerCase() === line.name.toLowerCase()
                    ) ? (
                      line.name.toLowerCase() !== "received-orders" ? (
                        <LinkToNewTab
                          key={i}
                          page={
                            complateReactList.filter(
                              (item) =>
                                item.name.toLowerCase() ===
                                line.name.toLowerCase()
                            )[0].link
                          }
                          isNewTab={
                            line.name.toLowerCase() === "received-orders"
                              ? true
                              : false
                          }
                        >
                          <li
                            className={
                              params.profilePage === line.name.toLowerCase()
                                ? "active-page"
                                : ""
                            }
                          >
                            {getTextByKey(line.text)}
                          </li>
                        </LinkToNewTab>
                      ) : (
                        <div className="received-orders-li" key={i}>
                          <LinkToNewTab
                            page={
                              complateReactList.filter(
                                (item) =>
                                  item.name.toLowerCase() ===
                                  line.name.toLowerCase()
                              )[0].link
                            }
                            isNewTab={
                              line.name.toLowerCase() === "received-orders"
                                ? true
                                : false
                            }
                          >
                            {" "}
                            <li
                              className={
                                params.profilePage === line.name.toLowerCase()
                                  ? "active-page"
                                  : ""
                              }
                            >
                              {getTextByKey(line.text)}
                            </li>
                          </LinkToNewTab>
                          {!isBusiness() && !isPremium() && (
                            <>
                              <div
                                className={`orders-count ${
                                  hoverCountOrders ? "hover-orders" : ""
                                }`}
                                onMouseEnter={() => setHoverCountOrders(true)}
                                onMouseLeave={() => mouseOutCountOrders()}
                              >
                                <h3>
                                  (
                                  {userData.Embed_Dynamic_Submissions_Per_Month
                                    ? userData.Embed_Dynamic_Submissions_Per_Month
                                    : 0}{" "}
                                  / {maxSubmissionsPerMonth})
                                </h3>
                                <div
                                  className={`upgrade-div ${
                                    hoverUpgradeDiv ? "hover-upgrade" : ""
                                  }`}
                                  onMouseEnter={() => setHoverUpgradeDiv(true)}
                                  onMouseLeave={() => leaveOutUpgradeDiv()}
                                >
                                  <div className="upgrade-div-content">
                                    {getTextByKey("available-orders-per-month")}
                                  </div>
                                  <div className="upgrade-div-button">
                                    <LinkToNewTab page={"plans"} isNewTab>
                                      <Button>
                                        {getTextByKey("upgrade-plan")}
                                      </Button>
                                    </LinkToNewTab>
                                  </div>
                                </div>{" "}
                              </div>
                            </>
                          )}
                        </div>
                      )
                    ) : advanceList.includes(line.name.toLowerCase()) ? null : (
                      <LinkToNewTab
                        key={i}
                        page={`user/${
                          item.category
                        }/${line.name.toLowerCase()}`}
                      >
                        <li
                          className={
                            params.profilePage === line.name.toLowerCase()
                              ? "active-page"
                              : ""
                          }
                        >
                          {getTextByKey(line.text)}
                        </li>
                      </LinkToNewTab>
                    )
                  )}
                {item.category === "jumbo-forms" && (
                  <div className="advanced-list-jumbo-forms">
                    <Accordion
                      title={
                        <div>
                          <h3>{getTextByKey("advanced-settings")}</h3>
                        </div>
                      }
                      menuParams={item.category}
                      defaultShow={
                        advanceList.includes(params.profilePage) ? true : false
                      }
                    >
                      <ul className="advance-settings-ul">
                        {item.content.map((line, i) =>
                          advanceList.includes(line.name.toLowerCase()) ? (
                            <LinkToNewTab
                              key={i}
                              page={`user/${
                                item.category
                              }/${line.name.toLowerCase()}`}
                            >
                              <li
                                className={
                                  params.profilePage === line.name.toLowerCase()
                                    ? "active-page"
                                    : ""
                                }
                              >
                                {getTextByKey(line.text)}
                              </li>
                            </LinkToNewTab>
                          ) : null
                        )}
                      </ul>
                    </Accordion>
                  </div>
                )}
              </>
            </ul>
          </Accordion>
        </div>
      ))}
    </div>
  );
};

export default DisplayMenu;
